module.exports = __webpack_public_path__ + "img/LoadOrderCardsStatus.af8197d0.png";